import { callFirebaseFunction } from "../callFirebaseFunction.ts"
import { SaveUserSettingsActionInput, UserSetting, UserSettingType } from "@cruisen/contract"
import { v4 as uuidv4 } from "uuid"
import { getAuth } from "firebase/auth"

export const saveUserSettings = async (
  input: SaveUserSettingsActionInput,
): Promise<UserSetting> => {
  const response = await callFirebaseFunction({
    name: "agentProfileAction",
    payload: {
      action: "saveUserSettings",
      ...input,
    },
  })
  if (response.error) {
    console.log(response)
    return undefined
  }

  return response.data?.result as UserSetting
}

export const getUserSettings = async (type: UserSettingType): Promise<UserSetting[]> => {
  const response = await callFirebaseFunction({
    name: "agentProfileAction",
    payload: {
      action: "getUserSettings",
      type,
    },
  })
  if (response.error) {
    console.log(response)
    return []
  }

  return response.data?.result as UserSetting[]
}

export const getPublicApiKey = async (): Promise<string> => {
  let publicApiKeyUserSetting: UserSetting

  const [existingUserSetting] = await getUserSettings("publicApiKey")
  if (existingUserSetting) {
    publicApiKeyUserSetting = existingUserSetting
  } else {
    publicApiKeyUserSetting = await saveUserSettings({
      type: "publicApiKey",
      key: uuidv4().replace(/-/g, ""),
      value: getAuth().currentUser.uid,
    })
  }

  if (!publicApiKeyUserSetting) return undefined

  return publicApiKeyUserSetting.key
}
